function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as ajax from './ajax';
import reportDocumentConstants from '../constants/reportDocumentConstants';
import tokenErrorActions from './tokenErrorActionCreators';
const reportDocumentActions = {
  /**
   * serverRenderReportDocument
   * @param reportDocumentID
   * @param cloudDocumentID
   */
  serverRenderReportDocument(reportDocumentID, cloudDocumentID) {
    return async dispatch => {
      const url = `/reportDocuments/render/${reportDocumentID}`;
      const additionalData = {
        cloudDocumentID,
        reportDocumentID
      };
      try {
        const response = await ajax.get(url, additionalData);
        if (response.data && response.data.pdfPath) {
          return dispatch(reportDocumentActions.renderSuccess(_objectSpread(_objectSpread({}, response.data), {}, {
            reportDocumentID
          })));
        }
        return dispatch(reportDocumentActions.renderFailure(reportDocumentID));
      } catch (e) {
        return dispatch(tokenErrorActions.handleError(e, 'reportDocument', reportDocumentActions.renderFailure.bind(this, reportDocumentID), reportDocumentActions.serverRenderReportDocument.bind(this, reportDocumentID, cloudDocumentID)));
      }
    };
  },
  // set the pdfPath
  renderSuccess({
    pdfPath,
    annotations,
    displayName,
    reportID: parentReportID,
    reportDocumentID,
    reportTypeID
  }) {
    return {
      type: reportDocumentConstants.RENDER_SUCCESS,
      pdfPath,
      annotations,
      displayName,
      parentReportID,
      reportTypeID,
      reportDocumentID
    };
  },
  // update error state
  renderFailure(reportDocumentID) {
    return {
      type: reportDocumentConstants.RENDER_FAILURE,
      reportDocumentID
    };
  },
  // reset - clear pdfPath, error and reset annotaitons to an empty array
  reset() {
    return {
      type: reportDocumentConstants.RESET
    };
  },
  /**
   * serverRenderAnnotatedDocument
   * @param reportDocumentID
   */
  serverRenderAnnotatedDocument(reportDocumentID) {
    return async dispatch => {
      const url = `/reportDocuments/render/${reportDocumentID}`;
      const additionalData = {
        reportDocumentID,
        annotateDocument: true
      };
      try {
        const response = await ajax.get(url, additionalData);
        if (response.data && response.data.pdfPath) {
          return dispatch(reportDocumentActions.renderAnnotatedSuccess(response.data));
        }
        return dispatch(reportDocumentActions.renderAnnotatedFailure(reportDocumentID));
      } catch (e) {
        return dispatch(tokenErrorActions.handleError(e, 'reportDocument', reportDocumentActions.renderAnnotatedFailure.bind(this, reportDocumentID), reportDocumentActions.serverRenderAnnotatedDocument.bind(this, reportDocumentID)));
      }
    };
  },
  // set the pdfPath
  renderAnnotatedSuccess({
    pdfPath
  }) {
    return {
      type: reportDocumentConstants.RENDER_ANNOTATED_SUCCESS,
      data: {
        downloadPDFPath: pdfPath
      }
    };
  },
  // update error state
  renderAnnotatedFailure(reportDocumentID) {
    return {
      type: reportDocumentConstants.RENDER_ANNOTATED_FAILURE,
      data: {
        reportDocumentID
      }
    };
  },
  // clear the download pdfPath
  clearDownloadPDFPath() {
    return {
      type: reportDocumentConstants.CLEAR_DOWNLOAD_PATH
    };
  }
};
export default reportDocumentActions;